import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../../core/hoc";
import classnames from 'classnames';
import { TextTransformService } from "../../../services";
var ModifiedBy = createComponent({
  displayName: 'ModifiedBy',
  propTypes: {
    date: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var className = classnames({
      ck: true,
      'modified-by': true,
      inverted: p.isInverted
    });
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, TextTransformService.modifiedBy(p.date, p.name));
  }
});
export default whitelistStyles()(ModifiedBy);
//# sourceMappingURL=index.js.map